export default {
  install: function(Vue, options) {
    Vue.mixin({
      computed: {
        isDevelopment() {
          return process.env.NODE_ENV === 'development'
        },
        isMobile() {
          return options ? options.isMobile : undefined;
        },
        isAndroid() {
          return options ? options.isAndroid: undefined
        },
        isMobileOnly() {
          return options ? options.isMobileOnly: undefined
        },
        isSafari() {
          return options ? options.isSafari: undefined
        },
        isClinius() {
          return process.env.VUE_APP_CUSTOMER === 'clinius'
        },
        isCliniusCh() {
          if (process.env.VUE_APP_CLINIUS_CH) {
            return process.env.VUE_APP_CLINIUS_CH === '1'
          } else return false;
        },
        isHager() {
          return process.env.VUE_APP_CUSTOMER === 'hager'
        },
        appId() {
          return process.env.VUE_APP_ID;
        }
      }
    })
  }
}
